import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <TopicsSection />
        <UpdatesSection />
        <FeaturesSection />
        <CarouselSection />
        <AboutSection />
        <AppSection />
        <CommentsSection />
        <FaqSection />
        <CardsSection />
        <ContactSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}